import { store } from '../store'

export default (to, from, next) => {
  console.log('view')
  if (!store.getters.user || (store.getters.user && store.getters.userData.Role === 'Supplier')) {
    next('/')
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/SupplierGuard.js